'use client';

import { Button } from '@eliadmin/core/src/components/ui/button';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { useToast } from '@eliadmin/core/src/components/ui/use-toast';
import { FaEnvelope } from 'react-icons/fa';

type SendCvEmailButtonProps = {
  offerName: string;
  targetEmail: string | null;
};

export const SendCvEmailButton = ({ offerName, targetEmail }: SendCvEmailButtonProps) => {
  const { t } = useTranslations();
  const { me } = useCustomerStore();
  const { toast } = useToast();

  const handleCreateEmail = async () => {
    if (!targetEmail) {
      toast({
        title: t('Emailový kontakt firmy nie je dostupný'),
        variant: 'destructive',
        duration: 5000,
      });
      return;
    }

    try {
      const subject = encodeURIComponent(`Životopis - reakcia na ponuku ${offerName}`);

      const userName = me?.customer
        ? `${me.customer.name ?? ''} ${me.customer.surname ?? ''}`.trim()
        : undefined;

      let curriculumUrl: string | undefined;
      if (me?.customer?.slug && typeof window !== 'undefined') {
        curriculumUrl = `${window.location.origin}/${me.customer.slug}`;
      }

      const bodyLines: string[] = [
        'Dobrý deň,',
        '',
        `zasielam Vám svoj životopis k pracovnej ponuke "${offerName}".`,
        '',
      ];

      if (curriculumUrl) {
        bodyLines.push(`Životopis: ${curriculumUrl}`, '');
      }

      if (userName) {
        bodyLines.push('S pozdravom', userName);
      }

      const body = encodeURIComponent(bodyLines.join('\n'));

      window.location.href = `mailto:${targetEmail}?subject=${subject}&body=${body}`;
    } catch (error) {
      toast({
        title: t('Nastala chyba pri vytváraní e‑mailu'),
        variant: 'destructive',
        duration: 5000,
      });
    }
  };

  return (
    <Button variant="link" onClick={handleCreateEmail}>
      <FaEnvelope size={20} />
      <p>Poslať životopis emailom</p>
    </Button>
  );
};

export default SendCvEmailButton;
